import * as THREE from 'three';
import { markRaw } from 'vue';

export default class CreateInspectionAreaModel {
  assetId = null;
  scanId = null;
  name = null;
  transform = null;

  constructor(assetId, name, positionX, positionY, positionZ, scanId = null) {
    this.assetId = assetId;
    this.scanId = scanId;
    this.name = name;

    this.transform = {
      position: {
        x: positionX || 0,
        y: positionY || 0,
        z: positionZ || 0,
      },
      scale: {
        x: 10,
        y: 10,
        z: 10,
        order: "XYZ",
        isEuler: false
      },
      rotation: {
        x: 0,
        y: 0,
        z: 0,
      },
    };

    this.generateMesh();
  }

  // Only the server-bound fields are serialized. `meshGroup` is a THREE.Group whose
  // parent<->children references are circular, so JSON.stringify (used by axios to build the
  // POST body) throws on it — which surfaced to the user as a misleading "No response received"
  // error because the request never actually left the browser. toJSON keeps meshGroup available
  // as a normal property for the viewer while emitting only what the create endpoint expects.
  toJSON() {
    return {
      assetId: this.assetId,
      scanId: this.scanId,
      name: this.name,
      transform: this.transform,
    };
  }

  generateMesh() {
    const geometry = new THREE.BoxGeometry(1, 1, 1);
    const edges = new THREE.EdgesGeometry(geometry);

    const material = new THREE.LineBasicMaterial({
      color: 0x66c7b4
    });

    const inspectionArea = new THREE.LineSegments(edges, material);

    const group = new THREE.Group();
    group.add(inspectionArea);

    group.position.set(
      this.transform.position.x,
      this.transform.position.y,
      this.transform.position.z
    );

    group.scale.set(
      this.transform.scale.x,
      this.transform.scale.y,
      this.transform.scale.z
    );

    group.rotation.set(
      this.transform.rotation.x,
      this.transform.rotation.y,
      this.transform.rotation.z
    );

    group.visible = false;

    this.meshGroup = markRaw(group);
  }
}